import type { ComponentChildren } from 'preact';
import { h } from 'preact';
import { Link } from 'wouter-preact';
import { useHashLocation } from 'wouter-preact/use-hash-location';

interface Props {
  show?: boolean;
  link: string;
  queryParams?: Record<string, string>;
  onClick?: () => void;
  id: string;
  children?: ComponentChildren;
  title: string;
}

export const PerksNavLink = ({ show = true, link, onClick, id, children, title }: Props) => {
  const [location] = useHashLocation();

  if (!show) return null;

  const isActive = location.includes(link);

  const handleClick = (e: MouseEvent) => {
    e.stopPropagation();
    onClick?.();
  };

  return (
    <li className={`desktop-nav-link ${isActive ? 'active' : ''}`} id={id} onClick={handleClick}>
      <Link to={link} title={title} aria-current={isActive ? 'page' : undefined}>
        <span class="h5 single-h5">{title}</span>
        {children}
      </Link>
    </li>
  );
};
